import React, { useState, useEffect } from 'react';
import { Table, Form } from 'react-bootstrap';
import Select from 'react-select';

const EditableTable = ({ initialData, totalRooms, handleSubmit }) => {
    const [data, setData] = useState(initialData);
  
    // input handle changes
    const handleInputChange = (e, rowIndex, key) => {
        const value = e.target.value === '' ? null : parseFloat(e.target.value);
        const newData = [...data];
        newData[rowIndex][key] = value;
        updateRowCalculations(newData, rowIndex);
        setData(newData);
    };
    const handleSelectChange = (selectedOption, rowIndex, key) => {
        const newData = [...data];
        newData[rowIndex][key] = selectedOption.value;
        setData(newData);
    };

    useEffect(() => {
        setData(initialData)
    }, [initialData])
    
    // row calculation
    const updateRowCalculations = (newData, rowIndex) => {
        const row = newData[rowIndex];
        row.available_rooms = totalRooms - (row.offline_rooms || 0);
        row.occupied_rooms_eod = (row.occupied_rooms_prev_day || 0) - (row.total_checkouts || 0) + (row.total_checkins || 0);
        row.stayovers = (row.occupied_rooms_prev_day || 0) - (row.total_checkouts || 0);
        row.occupancy_rate_available_eod = row.occupied_rooms_eod / row.available_rooms;
        row.occupancy_rate_totalkeys_eod = row.occupied_rooms_eod / totalRooms;
    };

    // init calculation
    useEffect(() => {
        const newData = data.map((row, index) => {
            updateRowCalculations(data, index);
            return row;
        });
        setData(newData);
    }, []);

    // Helper function to get day name from index
    const getDayName = (index) => {
        const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return daysOfWeek[(index - 1) % 7];
    };

    // render fields based on field types
    const renderEditableCell = (rowIndex, key) => {
        if (key === 'detail_status') {
            return (
                <Select
                    className='text-secondary text-center'
                    value={{ value: data[rowIndex][key], label: data[rowIndex][key] }}
                    onChange={(selectedOption) => handleSelectChange(selectedOption, rowIndex, key)}
                    options={[{ value: 'preliminary', label: 'preliminary' }, { value: 'final', label: 'final' }]}
                    defaultValue={{ value: 'preliminary', label: 'preliminary' }}
                />
            );
        } else if (key === 'status_val') {
            return (
                <Select
                    className='text-secondary text-center'
                    value={{ value: data[rowIndex][key], label: data[rowIndex][key] }}
                    onChange={(selectedOption) => handleSelectChange(selectedOption, rowIndex, key)}
                    options={[{ value: 'active', label: 'active' }, { value: 'inactive', label: 'inactive' }]}
                    defaultValue={{ value: 'active', label: 'active' }}
                />
            );
        } else if (key === 'detail_version') {
            return (
                <Form.Control
                    className='text-secondary text-center'
                    type="text"
                    value={data[rowIndex][key] || ''}
                    onChange={(e) => handleInputChange(e, rowIndex, key)}
                />
            );
        } else {
            return (
                <Form.Control
                    className='text-secondary text-center'
                    type="number"
                    value={data[rowIndex][key] || ''}
                    onChange={(e) => handleInputChange(e, rowIndex, key)}
                />
            );
        }
    };

    // render
    return (
        <>
            <Table responsive bordered hover className='table-responsive tb-transaction table shadow-hover mb-4 dataTable no-footer'>
                <thead>
                    <tr>
                        <th className='text-secondary fw-bold'></th>
                        {data.map((row, index) => (
                            <th key={index} className='text-primary fw-bold text-center'>{getDayName(row.day_of_week_index)}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th className='text-secondary fw-bold'>Detail Date</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{row.detail_date}</td>
                        ))}
                    </tr>
                    {/* Checkouts */}
                    <tr>
                        <th className='text-secondary fw-bold'>Total Checkouts</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{renderEditableCell(index, 'total_checkouts')}</td>
                        ))}
                    </tr>
                    <tr>
                        <th className='text-secondary fw-bold'>Early Checkouts</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{renderEditableCell(index, 'early_checkouts')}</td>
                        ))}
                    </tr>
                    <tr>
                        <th className='text-secondary fw-bold'>Late Checkouts</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{renderEditableCell(index, 'late_checkouts')}</td>
                        ))}
                    </tr>
                    <tr>
                        <th className='text-secondary fw-bold'>Group Checkouts</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{renderEditableCell(index, 'group_checkouts')}</td>
                        ))}
                    </tr>
                    {/* Checkins */}
                    <tr>
                        <th className='text-secondary fw-bold'>Total Checkins</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{renderEditableCell(index, 'total_checkins')}</td>
                        ))}
                    </tr>
                    <tr>
                        <th className='text-secondary fw-bold'>Early Checkins</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{renderEditableCell(index, 'early_checkins')}</td>
                        ))}
                    </tr>
                    <tr>
                        <th className='text-secondary fw-bold'>Late Checkins</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{renderEditableCell(index, 'late_checkins')}</td>
                        ))}
                    </tr>
                    <tr>
                        <th className='text-secondary fw-bold'>Group Checkins</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{renderEditableCell(index, 'group_checkins')}</td>
                        ))}
                    </tr>
                    <tr>
                        <th className='text-secondary fw-bold'>VIPs</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{renderEditableCell(index, 'vips')}</td>
                        ))}
                    </tr>
                    <tr>
                        <th className='text-secondary fw-bold'>Offline Rooms</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{renderEditableCell(index, 'offline_rooms')}</td>
                        ))}
                    </tr>
                    <tr>
                        <th className='text-secondary fw-bold'>Unsold Rooms</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{renderEditableCell(index, 'unsold_rooms')}</td>
                        ))}
                    </tr>
                    {/* <tr>
                    <th className='text-secondary fw-bold'>Detail Status</th>
                    {data.map((row, index) => (
                        <td key={index} className='text-secondary text-center'>{renderEditableCell(index, 'detail_status')}</td>
                    ))}
                </tr>
                <tr>
                    <th className='text-secondary fw-bold'>Status Value</th>
                    {data.map((row, index) => (
                        <td key={index} className='text-secondary text-center'>{renderEditableCell(index, 'status_val')}</td>
                    ))}
                </tr>
                <tr>
                    <th className='text-secondary fw-bold'>Detail Version</th>
                    {data.map((row, index) => (
                        <td key={index} className='text-secondary text-center'>{renderEditableCell(index, 'detail_version')}</td>
                    ))}
                </tr> */}
                    {/* Calculated Fields */}
                    <tr>
                        <th className='text-secondary fw-bold'>Occupied Rooms EOD</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{row.occupied_rooms_eod}</td>
                        ))}
                    </tr>
                    <tr>
                        <th className='text-secondary fw-bold'>Stayovers</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{row.stayovers}</td>
                        ))}
                    </tr>
                    <tr>
                        <th className='text-secondary fw-bold'>Available Rooms</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{row.available_rooms}</td>
                        ))}
                    </tr>
                    <tr>
                        <th className='text-secondary fw-bold'>Occupancy Rate Available EOD</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{(row.occupancy_rate_available_eod * 100).toFixed(2)}%</td>
                        ))}
                    </tr>
                    <tr>
                        <th className='text-secondary fw-bold'>Occupancy Rate Total EOD</th>
                        {data.map((row, index) => (
                            <td key={index} className='text-secondary text-center'>{(row.occupancy_rate_totalkeys_eod * 100).toFixed(2)}%</td>
                        ))}
                    </tr>
                </tbody>
            </Table>
            <div className='text-center'>
                <button type='button' className='btn btn-primary' onClick={() => handleSubmit(data)}>
                    Submit
                </button>
            </div>
        </>
    );
};

export default EditableTable;
